/*global define:false*/
define('contentTypeDetailRow',['contentTypeDetailView', 'contentTypeDetailRowConfig'],
    function (contentTypeDetailView, contentTypeDetailRowConfig) {
        'use strict';

        return contentTypeDetailView.extend({
            defaultOptions : contentTypeDetailRowConfig
        });

    });

